// extracted by mini-css-extract-plugin
export default {"root":"_1cvtn","text-block":"BG_ge","textBlock":"BG_ge","prefix":"_3yAXU"};